import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowRight, Trophy, ExternalLink } from 'lucide-react';
import GoogleReviews from './GoogleReviews';
const CompanyOpening = () => {
  const benefits = ['Orientação completa desde o início do negócio', 'Análise tributária para enquadramento correto', 'Suporte especializado em todas as etapas', 'Abertura de empresa com segurança e planejamento'];
  const phoneNumber = '5555984328501'; // WhatsApp number
  const whatsappMessage = encodeURIComponent('Olá! Gostaria de saber mais sobre a abertura da minha empresa com a TALC Assessoria Contábil.');
  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${whatsappMessage}`, '_blank');
  };
  return <section className="py-12 bg-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="flex justify-center">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-center mx-auto max-w-4xl px-4 lg:px-0">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#c99b36]/10 text-[#c99b36] rounded-full font-semibold mb-6">
              <Trophy size={18} />
              <span>Referência em Santo Ângelo</span>
            </div>
            
            <h2 className="text-3xl md:text-4xl font-bold text-[#0a4b3c] mb-6 leading-snug">
              A Contabilidade Mais Bem Avaliada no Google
            </h2>
            
            {/* Google reviews (fetched via /api/google-reviews). Falls back to CTA when unavailable. */}
            <React.Suspense fallback={<div className="p-4">Carregando avaliações...</div>}>
              <GoogleReviews />
            </React.Suspense>

            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Comece sua jornada empreendedora com quem realmente entende do assunto. Somos especialistas em contabilidade empresarial em Santo Ângelo e região, oferecendo todo o suporte necessário para o seu sucesso desde o primeiro dia.
            </p>
            <div className="grid sm:grid-cols-2 gap-6 mb-8 text-left">
              {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3">
                  <CheckCircle className="text-[#0a4b3c] w-5 h-5 flex-shrink-0 mt-1" />
                  <span className="text-gray-700">{benefit}</span>
                </div>)}
            </div>

            <motion.button whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.98
          }} onClick={handleWhatsAppClick} className="bg-[#0a4b3c] hover:bg-[#063127] text-white px-8 py-4 rounded-lg font-semibold text-lg flex items-center gap-3 shadow-md hover:shadow-[#0a4b3c]/20 transition-all duration-200">
              Quero Abrir Minha Empresa
              <ArrowRight className="w-5 h-5" />
            </motion.button>
          </motion.div>
        </div>
      </div>
    </section>;
};
export default CompanyOpening;